import script from "./CheckoutView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutView.vue?vue&type=script&setup=true&lang=ts"

import "./CheckoutView.vue?vue&type=style&index=0&id=f042b24c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f042b24c"]])

export default __exports__